import { createContext, type ReactNode } from 'react';
import type { User } from '@ridemaadi/types';

export interface AuthContextValue {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  profileComplete: boolean;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function StaticAuthProvider({
  value,
  children,
}: {
  value: AuthContextValue;
  children: ReactNode;
}) {
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
